export default __webpack_public_path__ + "static/media/tesla.5f8964d5.svg";